var tempNamespace = {};

var disableOnMobile = ['leaderbord', 'megaboard', 'pozadiL', 'pozadiR', 'bottom', 'box2'];

var placeBanner = function(spaceName, zoneId)
{
    // console.log('placeBanner zoneId='+zoneId+' caller='+(new Error()).stack.split("\n")[2].trim().split(" ")[1]);
    // console.log(new Error().stack);

    if (typeof tempNamespace[spaceName] != 'undefined')
        {
            var m3_u = (location.protocol == 'https:' ? 'https://adv.ceskestavby.cz/www/delivery/ajs.php' : 'http://adv.ceskestavby.cz/www/delivery/ajs.php');
            var m3_r = Math.floor(Math.random() * 99999999999);
            if (!document.MAX_used)
                document.MAX_used = ',';
            document.write("<scr" + "ipt type='text/javascript' src='" + m3_u);
            document.write("?what=" + tempNamespace[spaceName]);
            document.write('&amp;cb=' + m3_r);
            if (document.MAX_used != ',')
                document.write("&amp;exclude=" + document.MAX_used);
            document.write(document.charset ? '&amp;charset=' + document.charset : (document.characterSet ? '&amp;charset=' + document.characterSet : ''));
            document.write("&amp;loc=" + escape(window.location));
            if (document.referrer)
                document.write("&amp;referer=" + escape(document.referrer));
            if (document.context)
                document.write("&context=" + escape(document.context));
            if (document.mmm_fo)
                document.write("&amp;mmm_fo=1");
            document.write("'><\/scr" + "ipt>");
        }
        else
        {
            OA_show(zoneId);
        }
};